import MinigamesApi from "@libs/api/MinigamesApi";

class GlobalApi extends MinigamesApi {
  constructor() {
    super();
    this.setBaseUrl("/minigames/"); // пишем сюда наш базовый URL к API, от которого будут формироваться остальные URLы
  }

  getBattlepassStatus() {
    return this.get("activity/info?code=battlepass");
  }

  getUserInfo() {
    return this.get("/battlepass/user/info");
  }
  startEvent() {
    return this.post("/battlepass/user/start");
  }
}
export default GlobalApi;
